<template>  
    <div id="wrapper" class="pb-5 mb-5 bg-white h-100vh">
        <div class="container">
            <div class="row align-items-center justify-content-center h-100">
                <div class="col-12 col-lg-6">
                    <div class="imgcontainer text-center mb-4">
                        <img src="../../../../static/website/images/logo.svg" alt="Logo" class="avatar">
                    </div>
                    <div class="loginElement position-relative">
                        <loader v-if="pageLoader"></loader>
                        <div class="subtitle">
                            <h3> Reset Password</h3>
                            <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                        </div>
                        <div class="stepForm" v-show='displayMessage'>
                            <p>Password has been changed successfully. Click  <router-link :to="'/'">  Here </router-link>to log in</p>
                        </div> 
                        <div class="stepForm" v-show='!displayMessage'>
                            <div class="form-group iconInput">
                                <div class="position-relative">
                                    <input :type="inputtype" placeholder="Password" v-model="password" class="float-field form-control" v-validate="{ required: true ,regex : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,24}$/ , is: confirmPassword }" name="password" :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" >
                                    <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('1')"></feather> 
                                </div>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('password')">{{ error }}
									<!-- <span v-show="error == 'The password field is required.'">The password field is required</span>
									<span v-show="error == 'The password field format is invalid.'">Your password must contain at least 6 characters, and include at least 1 number, 1 uppercase character and 1 special character (!@#$%^&*/)</span> -->
								</p>
                            </div> 
                            <div class="form-group iconInput">
                                <div class="position-relative">
                                    <input :type="inputtype1" placeholder="Confirm Password" v-model="confirmPassword" class="float-field form-control" v-validate="'required'" name="confirm password" :class="{ 'is-invalid': submitted && errors.has('confirm password') }" ref="confirmPasswordInput" >
                                    <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('2')"></feather> 
                                </div>
                                <p class="error" v-if="submitted" v-for="error in errors.collect('confirm password')">{{ error }}
                                    <!-- <span v-show="error == 'The confirmPassword field is required.'">The confirm password field is required.</span>
                                    <span v-show="error == 'The confirmPassword confirmation does not match.'">The entered passwords do not match. Please try again</span> -->
                                </p>
                            </div> 
                            <div class="clearfix"></div>
                            <div class="submitButton text-center">
                                <button class="btn btn-link btn-blue w-100" v-on:click.prevent="submit()"> Reset Password</button>
                                <div class="forgot_sec mt-3">
                                    <router-link :to="'/'" class="forgotpassword d-flex justify-content-center">
                                        <feather type="chevron-left" class="mr-1"></feather>Back to log in page
                                    </router-link>     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    //import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Forgot-password',
        data() {
            return {
                "password" : "",
                "confirmPassword":"",
                submitted: false,
                inputtype1: 'password',
                inputtype: 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                showpassword: false,
                showpassword1: false,
                displayMessage: false,
                pageLoader : false,
                response_msg : '',
                msg_type : '',
            }
        },
        methods:{
            ...mapActions({
                _runResetPasswordFromHash: types.RUN_RESET_PASSWORD_FROM_HASH
            }),
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            },
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "password": _that.password,
                                "cpassword": _that.confirmPassword,
                                "hash": _that.hash

                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runResetPasswordFromHash(input_json)
                    }
                });
            }
        },
        created(){
			this.hash = this.$route.params.hash
            //this.hash = this.$route.params.hash
            // console.log(params)            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/user/ResetPasswordFromHash.vue